import { app } from '../../../../app';
import { Controller } from './oauth-endpoints.controller';

app.component('oauthEndpoints', {
    bindings: {
        clientId: '<',
        credentials$: '<',
    },
    controller: Controller,
    templateUrl: require('./oauth-endpoints.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/app-integration-instructions/oauth-endpoints/oauth-endpoints.component.js